import Vue from 'vue';
import VueRouter from 'vue-router';
import { isMobile } from 'mobile-device-detect';
import liff from '@line/liff';
import { PublicPath } from '@/config';
import functionRoute from './functionRoute';
import store from '@/store';

Vue.use(VueRouter);

// 解決 ElementUI 導航欄，在 vue-router 3.0 版本以上重複點菜單報錯問題
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

/* 因應 SSO 登入機制，若頁面需要帶 query 要全小寫，並調整 route-authentication */
let routes = [
  {
    path: '/membercenter',
    name: 'index',
    component: () => {
      if (isMobile) { return import('@/views/index/IndexMobile.vue'); }
      return import('@/views/index/IndexPC.vue');
    },
  },
  {
    path: '/redeem',
    name: 'redeemList',
    component: () => {
      if (isMobile) { return import('@/views/redeem/RedeemListMobile.vue'); }
      return import('@/views/redeem/RedeemListPC.vue');
    },
    children: [
      {
        path: '/redeem/:no',
        name: 'redeemDetail',
        component: () => import('@/components/redeem/RedeemDetail.vue'),
        props: (route) => ({ ...route.params }),
      },
    ],
  },
  {
    path: '/redeemcart',
    name: 'redeemCart',
    component: () => {
      if (isMobile) { return import('@/views/redeem/RedeemCartMobile.vue'); }
      return import('@/views/redeem/RedeemCartPC.vue');
    },
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => {
      if (isMobile) { return import('@/views/invite/MgmInviteMobile.vue'); }
      return import('@/views/invite/MgmInvitePC.vue');
    },
    beforeEnter: (to, from, next) => {
      let activityID = '';
      const state = to.query['liff.state'];
      if (!to.query.activityId) {
        if (to.query.activityid) {
          activityID = to.query.activityid;
        } else if (state) {
          const ary = state.split('?')[1].split('&');
          const temp = [];
          for (let i = 0; i <= ary.length - 1; i += 1) {
            const a = ary[i].split('=')[1];
            temp[ary[i].split('=')[0]] = a;
          }
          activityID = temp.activityid;
        }

        const param = to.query;
        param.activityId = activityID;

        const { userAgent } = navigator;
        if (userAgent.indexOf('Line') > -1) {
          store.dispatch('getOfficalAccount', to.query.companyid).then((res) => {
            if (res.success) {
              const liffid = res.data[0].param.find((x) => x.channelParam === 'MgmInviteLiff').channelParamValue;
              // 沒做 init 會導頁三次
              liff.init({ liffId: liffid }).then(() => {
                next({ name: to.name, query: param });
              }).catch(() => {
                window.location.href = `${window.location.href}&openExternalBrowser=1`;
              });
            }
          });
        } else if (to.hash !== '') {
          next({ name: to.name, query: param });
        } else {
          next();
        }
      } else {
        next();
      }
    },
  },
  {
    path: '/redeemcomplete',
    name: 'redeemComplete',
    component: () => {
      if (isMobile) { return import('@/views/redeem/RedeemCompleteMobile.vue'); }
      return import('@/views/redeem/RedeemCompletePC.vue');
    },
  },
  {
    path: '/complete',
    name: 'complete',
    component: () => {
      if (isMobile) { return import('@/views/complete/CompleteMobile.vue'); }
      return import('@/views/complete/CompletePC.vue');
    },
  },
  {
    path: '/Error',
    name: 'Error',
    props: true,
    component: () => import('@/components/ErrorPage.vue'),
  },
];

// 手機版直接加入 routes 中，非手機版加入 children
if (isMobile) {
  const mobileRoutes = [
    {
      path: '/membercenter/order',
      name: 'order',
      component: () => import('@/views/order/OrderMobile.vue'),
    },
    {
      path: '/membercenter/personalinfo',
      name: 'personalInfo',
      component: () => import('@/views/personalInfo/PersonalInfoEditMobile.vue'),
    },
    {
      path: '/membercenter/pointHistory',
      name: 'pointHistory',
      component: () => import('@/views/pointHistory/PointHistoryMobile.vue'),
    },
    {
      path: '/membercenter/redeemhistory',
      name: 'redeemHistory',
      component: () => import('@/views/redeemHistory/RedeemHistoryMobile.vue'),
      children: [
        {
          path: '/membercenter/redeemhistory/writeOffPage',
          name: 'writeOffPage',
          component: () => import('@/components/redeemHistory/GiftWriteOff.vue'),
          props: true,
        },
      ],
    },
    {
      path: '/membercenter/notification',
      name: 'notification',
      component: () => import('@/views/notification/NotificationMobile.vue'),
    },
    {
      path: '/membercenter/returnRequest',
      name: 'returnRequest',
      component: () => import('@/views/returnRequest/ReturnRequestMobile.vue'),
    },
    {
      path: '/membercenter/mcfwallet',
      name: 'mcfwallet',
      component: () => import('@/views/mcfwallet/McfWalletMobile.vue'),
    },
  ];

  routes = routes.concat(mobileRoutes);
} else {
  const pcRoutesChild = [
    {
      path: '/membercenter/order',
      name: 'order',
      component: () => import('@/views/order/OrderPC.vue'),
    },
    {
      path: '/membercenter/personalinfo',
      name: 'personalInfo',
      component: () => import('@/views/personalInfo/PersonalInfoEditPC.vue'),
    },
    {
      path: '/membercenter/pointHistory',
      name: 'pointHistory',
      component: () => import('@/views/pointHistory/PointHistoryPC.vue'),
    },
    {
      path: '/membercenter/redeemhistory',
      name: 'redeemHistory',
      component: () => import('@/views/redeemHistory/RedeemHistoryPC.vue'),
      children: [
        {
          path: '/membercenter/redeemhistory/writeOffPage',
          name: 'writeOffPage',
          component: () => import('@/components/redeemHistory/GiftWriteOff.vue'),
          props: true,
        },
      ],
    },
    {
      path: '/membercenter/notification',
      name: 'notification',
      component: () => import('@/views/notification/NotificationPC.vue'),
    },
    {
      path: '/membercenter/returnRequest',
      name: 'returnRequest',
      component: () => import('@/views/returnRequest/ReturnRequestPC.vue'),
    },
    {
      path: '/membercenter/mcfwallet',
      name: 'mcfwallet',
      component: () => import('@/views/mcfwallet/McfWalletPC.vue'),
    },
  ];

  routes.find((x) => x.name === 'index').children = pcRoutesChild;
}

// 引入跳轉用route
routes = routes.concat(functionRoute);

const router = new VueRouter({
  mode: 'history',
  base: PublicPath,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

export default router;
